/** Session-UI fancy toggles — align with Frontend-UI FancySocketMarketMapper. */

/** Per-fancy Suspend toggle — only `isSuspended` (not market-level suspend). */
export function fancySuspendOn(details: {
  isSuspended?: boolean
  isMarketSuspended?: boolean
}): boolean {
  return Boolean(details.isSuspended)
}

export function fancyStatusOn(status: boolean | string | undefined): boolean {
  return status === true || status === 'Enable'
}

/** Lab: Ball Running and market Suspend are mutually exclusive. */
export function nextMarketFlags(
  current: { isMarketSuspended: boolean; ballChalu: boolean },
  flip: 'suspend' | 'ball',
): { isMarketSuspended: boolean; ballChalu: boolean } {
  if (flip === 'suspend') {
    const isMarketSuspended = !current.isMarketSuspended
    return {
      isMarketSuspended,
      ballChalu: isMarketSuspended ? false : current.ballChalu,
    }
  }
  const ballChalu = !current.ballChalu
  return {
    ballChalu,
    isMarketSuspended: ballChalu ? false : current.isMarketSuspended,
  }
}

/** Apply server fancy row after update / horse selection (clears suspend). */
export function fancyFlagsFromUpdateResponse(data: {
  isSuspended?: boolean
  isMarketSuspended?: boolean
  ballChalu?: boolean
  runButtonValue?: number
  status?: boolean | string
}): {
  isSuspended?: boolean
  isMarketSuspended?: boolean
  ballChalu?: boolean
  runButtonValue?: number
  status?: boolean | string
} {
  const patch: {
    isSuspended?: boolean
    isMarketSuspended?: boolean
    ballChalu?: boolean
    runButtonValue?: number
    status?: boolean | string
  } = {}
  if (typeof data.isSuspended === 'boolean') patch.isSuspended = data.isSuspended
  if (typeof data.isMarketSuspended === 'boolean') {
    patch.isMarketSuspended = data.isMarketSuspended
  }
  if (typeof data.ballChalu === 'boolean') patch.ballChalu = data.ballChalu
  if (data.runButtonValue != null && Number.isFinite(Number(data.runButtonValue))) {
    patch.runButtonValue = Number(data.runButtonValue)
  }
  if (data.status === 'Enable') patch.status = true
  else if (data.status === 'Disable') patch.status = false
  else if (typeof data.status === 'boolean') patch.status = data.status
  return patch
}
